// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
/**
 * @packageDocumentation
 * @module metadataform
 */
import { Token } from '@lumino/coreutils';
/**
 * The metadata form provider token.
 */
export const IMetadataFormProvider = new Token('@jupyterlab/metadataform:IMetadataFormProvider', `A service to register new metadata editor widgets.`);
//# sourceMappingURL=token.js.map